/* hs-eslint ignored failing-rules */
/* eslint-disable conversations/no-dynamic-i18n */

'use es6';

import PropTypes from 'prop-types';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import FullSenderName from '../senders/components/FullSenderName';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { getVerboseDateText } from 'conversations-message-history/util/getVerboseDateText';
import { chooseAssignmentMessage } from './operators/chooseAssignmentMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const AssignmentLabel = ({
  activeAgentId,
  assignorSender,
  assigneeSender,
  isLoading,
  timestamp
}) => {
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "skeleton-text",
      width: 200,
      use: "on-shade"
    });
  }
  const assignorName = assignorSender && /*#__PURE__*/_jsx(FullSenderName, {
    sender: assignorSender
  });
  const assigneeName = assigneeSender && /*#__PURE__*/_jsx(FullSenderName, {
    sender: assigneeSender
  });
  const date = getVerboseDateText(timestamp);
  const {
    i18nKey,
    options,
    testId
  } = chooseAssignmentMessage({
    assignorSender,
    assigneeSender,
    activeAgentId,
    assignorName,
    assigneeName,
    date
  });
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: i18nKey,
    options: options,
    "data-test-id": testId
  });
};
AssignmentLabel.displayName = 'AssignmentLabel';
AssignmentLabel.propTypes = {
  activeAgentId: PropTypes.string.isRequired,
  assigneeSender: RecordPropType('Sender'),
  assignorSender: RecordPropType('Sender'),
  isLoading: PropTypes.bool,
  timestamp: PropTypes.number.isRequired
};
export default AssignmentLabel;